
define('eteration/widgets/ui-portselect',[
	'knockout',
	'bloodhound',
	'eteration/eteration-ajax',
	'ui-helper/storage-helper',
	'eteration/eteration-i18n',
	'eteration/eteration-base',
	'diacritics-helper',
	'underscore',
	'bootstrap.select',
	'perfect-scrollbar.jquery',
	'perfect-scrollbar'
], 
function(ko, Bloodhound, etrAjax, storageHelper, i18n, Eteration, diacriticsHelper, underscore) {

	var escapeHtmlEntityMap = {
		"&" : "&amp;",
		"<" : "&lt;",
		">" : "&gt;",
		'"' : '&quot;',
		"'" : '&#39;',
		"/" : '&#x2F;'
	};

	var escapeHtml = function(string) {
		return String(string).replace(/[&<>"'\/]/g, function(s) {
			return escapeHtmlEntityMap[s];
		});
	}

	$.ajaxSetup({
		beforeSend : function(xhr,settings) {
			xhr.setRequestHeader("Accept-Language", i18n.getUserLocale());
			xhr.setRequestHeader("country", i18n.getUserCountry());
			xhr.setRequestHeader('cId', window.cId);
			xhr.setRequestHeader('page', window.location.href);
			xhr.setRequestHeader('requestId', etrAjax.requestId());
			xhr.setRequestHeader('pageRequestId', etrAjax.pageRequestId());
			if(storageHelper.getItem({ key: "locations_version_number", webStorageType: storageHelper.Stores.SESSION_STORAGE }) != null){
				settings.url += "?_="+storageHelper.getItem({ key: "locations_version_number", webStorageType: storageHelper.Stores.SESSION_STORAGE });
			}
			else {
				settings.url += "?_="+(new Date(new Date().setMinutes(0,0,0))).getTime();
			}

		}
	});
	var sessionId = i18n.getMetaDataAttribute("jsessionid");
	if (!sessionId) {
		sessionId = "";
	}
	var blackList = ['Uluslararası', 'Ulusal', 'Bölgesel', 'Havaalanı', 'Havalimanı', 'Airport', 'International', 'Railway', 'Train', 'Station', 'Tren', 'İstasyon', 'İstasyonu', 'Regional'];
	
	var locations = new Bloodhound({
		datumTokenizer : function(d) {
			var nameItems, i, j, k, m, l, y, z, predictionsItems;
			if (d) {
				var tokens = [];
				if (d.city) {
					tokens.push(d.city.code);
					
					if(d.city.name) {
						nameItems = diacriticsHelper.removeDiacritics(d.city.name).split(/[\s-]+/);
						for (i = 0; i < nameItems.length; i++) {
							tokens.push(nameItems[i]);
						}
					}
				}
				if (d.name) {
					nameItems = underscore.filter(d.name.split(/[\s-']+/), function(elem) {
						return !underscore.contains(blackList, elem);
					});
					for (i = 0; i < nameItems.length; i++) {
						tokens.push(nameItems[i]);
						tokens.push(diacriticsHelper.removeDiacritics(nameItems[i]));
					}
				}
				if (d.ports) {
					for (m = 0; m < d.ports.length; m++) {
						tokens.push(d.ports[m]);
					}
				}

				if (d.port && d.port.data.predictions) {
					for (j = 0; j < d.port.data.predictions.length; j++) {
						predictionsItems = underscore.filter(d.port.data.predictions[j].split(' '), function(elem) {
							return !underscore.contains(blackList, elem);
						});
						for (z = 0; z < predictionsItems.length; z++) {
							tokens.push(diacriticsHelper.removeDiacritics(predictionsItems[z]));
						}
					}
				}

				if (d.city && d.city.data.predictions) {
					for (k = 0; k < d.city.data.predictions.length; k++) {
						predictionsItems = underscore.filter(d.city.data.predictions[k].split(' '), function(elem) {
							return !underscore.contains(blackList, elem);
						});
						for (y = 0; y < predictionsItems.length; y++) {
							tokens.push(diacriticsHelper.removeDiacritics(predictionsItems[y]));
						}
					}
				}

				if (d.country && d.country.data.predictions) {
					for (l = 0; l < d.country.data.predictions.length; l++) {
						predictionsItems = underscore.filter(d.country.data.predictions[l].split(' '), function(elem) {
							return !underscore.contains(blackList, elem);
						});
						for (y = 0; y < predictionsItems.length; y++) {
							tokens.push(diacriticsHelper.removeDiacritics(predictionsItems[y]));
						}
					}
				}

				if (d.code) {
					tokens.push(d.code);
				}
				tokens = underscore.without(underscore.uniq(tokens),'');
				
				return tokens;
			} else {
				return [];
			}
		},
		queryTokenizer : Bloodhound.tokenizers.whitespace,
		limit : 50,
		prefetch : {
			url : '/com.thy.web.online.ibs/ibs/booking/locations/TK/' + i18n.getUserLocale(),
			thumbprint : window.appVersion,
			cache: false,
			cacheKey: 'ui-portselect-ports' + '-' +i18n.getUserLocale(),
			filter : function(response) {
				var result = [];

				if(response.data != null && response.data.ports != null) {
					if(window.location.href.indexOf('miles-and-smiles') > -1){
						result = result.concat(underscore.where(response.data.ports));//M&S ports
					} else {
						result = result.concat(underscore.where(response.data.ports, {hideInBooker: false}));
					}
					
					result = result.concat(response.data.countries);
				}
				return result;
			}
		}
	});
	

	locations.clearPrefetchCache();

	locations.initialize();

	ko.bindingHandlers.portselect = {

		setValue : function(allBindingsAccessor, val) {
			if (val !== undefined) {
				if (allBindingsAccessor().value() !== undefined && allBindingsAccessor().value().code !== undefined) {
					allBindingsAccessor().value(val);
				} else {
					if (val.code) {
						if (allBindingsAccessor().portselect.citySelected) {
							allBindingsAccessor().portselect.citySelected(val.multi);
						}

						if (allBindingsAccessor().portselect.selectedPortData) {
							allBindingsAccessor().portselect.selectedPortData(val);
						}
						allBindingsAccessor().value(val.code);
					} else {
						allBindingsAccessor().value(val);
					}
				}
			}
		},

		processAward : function(awardOnly, resultArr) {
			var result = [];
			if (!awardOnly) {
				return resultArr;
			} else {
				for (var j = 0; j < resultArr.length; j++) {
					var option = resultArr[j];
					if (option.awardTicket) {
						if (option.type === "port" || option.type === "country" || option.type === "city") {
							result.push(option);
						}
					}
				}
			}
			return result;
		},
		processStarAward : function(starAwardOnly, resultArr) {
			var result = [];
			if (!starAwardOnly) {
				return resultArr;
			} else {
				for (var j = 0; j < resultArr.length; j++) {
					var option = resultArr[j];
					if (option.starAwardTicket) {
						if (option.type === "port" || option.type === "country" || option.type === "city") {
							result.push(option);
						}
					}
				}
			} 
			return result;
		},
		processRestrictedPorts : function(restrictedPortsObs, resultArr) {
			var restrictedPorts = [];
			if (restrictedPortsObs) {
				restrictedPorts = ko.unwrap(restrictedPortsObs);
			}
			var result = [];
			for (var i = 0; i < resultArr.length; i++) {
				var option = resultArr[i];
				for (var j = 0; j < restrictedPorts.length; j++) {
					var rp = restrictedPorts[j];
					if (option.port && option.port.code === rp && (option.type === "port" || option.type === "city")) {
						result.push(option)
					}
				}
			}
			return result;
		},
		setupInitialPort : function(element, valueAccessor, allBindingsAccessor, icon, promt) {
			var initialVal = valueAccessor().init;
			var multi = true;
			var domestic = true;
			
			var restrictedPortsObs = valueAccessor().restrictedPorts;
			var changeFlightFlow = valueAccessor().changeFlightFlow;
			
			
			var $element = $(element);
			if (initialVal && initialVal !== ' ') {
				var val = initialVal();
				if(val && val !== ' ') {
					if (val.code) {
						domestic = val.domestic;
						multi = val.multi;					
						val = val.code;
					}
					locations.get(val, function(resultArr) {
						$element.selectpicker('refresh');
						if (resultArr.length > 0) {
							var promocode=[];
							if(location.hash&&location.hash.length==17){
							    promocode.push(location.hash.substring(1,4));
							    promocode.push(location.hash.substring(location.hash.length-3,location.hash.length));
							}
							
							if(promocode.length>0){
							    resultArr = resultArr.filter(function(item){
							       return (item.code==promocode[0]||item.code==promocode[1]) && item.type=="port";
							    });
							}
							if(changeFlightFlow && restrictedPortsObs){
								resultArr = ko.bindingHandlers.portselect.processRestrictedPorts(restrictedPortsObs, resultArr);
							}

							if(resultArr.length > 1){
								ko.utils.arrayForEach(resultArr, function(item){
									if(val === item.code){
										resultArr = [];
										resultArr.push(item);
									}
								});
							}

							ko.bindingHandlers.portselect.processSearchPortResult(resultArr, $element, icon, promt, valueAccessor);
						} else {
							multi = false;
							var optiongroupPortsHTML = promt + '<option data-icon="icon-globe" value="cityList" data-content="<i class=\'glyphicon icon-globe\'></i><span class=\'label-full 7\'>' + i18n.get('Link-OB-01') + '</span>">' + i18n.get('Link-OB-01') + '</option>' + '';
							$element.html(optiongroupPortsHTML);
							valueAccessor().init(' ');
						}
						ko.bindingHandlers.portselect.setValue(allBindingsAccessor, {
							'code' : val,
							'multi' : multi,
							'domestic' : domestic
						});
	
						var hasMulti = underscore.any(resultArr, function(item){return item.multi;});
																
						if (multi||hasMulti) {
							var index = 0;
							for (var int = 0; int < resultArr.length; int++) {
								if (resultArr[int].multi==multi && val && val==resultArr[int].code) {
									index = int;
									break;
								}
							}
	
							if($element.find('option').length > index+1)
								$element.find('option')[index+1].selected = true;
						}
						$element.selectpicker('refresh');
						if (val && val.length == 3) {
							$('#country' + val).text('');
							$('#city' + val).text('');
						}
						ko.bindingHandlers.portselect.addCityListEvents(element, valueAccessor, allBindingsAccessor, icon, promt);
						ko.bindingHandlers.portselect.inputChangedEvent(element, valueAccessor, allBindingsAccessor);
					});
				}
			}
		},

		init : function(element, valueAccessor, allBindingsAccessor) {

			var $element = $(element);

			var accessor = valueAccessor();

			var showSubtext = accessor.showSubtext || true;

			var liveSearch = accessor.liveSearch || true;

			var dropupAuto = accessor.dropupAuto || false;

			var size = accessor.size || false;

			var initialVal = accessor.init;

			var awardOnly = accessor.awardOnly || false;
			
			var starAwardOnly = accessor.starAwardOnly || false;

			var getAllPorts = accessor.getAllPorts || false;

			var inputFocusHandler = accessor.inputFocusHandler;

			var resizeBackground = accessor.resizeBackground;

			var restrictedPortsObs = accessor.restrictedPorts;
			var restrictedCountries = accessor.restrictedCountries;
			
			var notificationFieldId = accessor.notificationFieldId;

			var from = accessor.from || false;
			
			var passivePorts = []
			var icon = 'icon-plane';

			if (!from) {
				icon = 'icon-plane2';
			}

			var promt = '<option value="" data-content="<span class=\'empty\'>' + i18n.get('Label-OB-61') + '</span><i class=\'glyphicon icon-plane rotateRTL\'></i>"></option>';
			if (!from)
				promt = '<option value="" data-content="<span class=\'empty\'>' + i18n.get('Label-OB-60') + '</span><i class=\'glyphicon icon-plane2 rotateRTL\'></i>"></option>';

			$element.html(promt);

			if (ko.isObservable(initialVal)) {

				initialVal.subscribe(function() {
					ko.bindingHandlers.portselect.setupInitialPort(element, valueAccessor, allBindingsAccessor, icon, promt);
				});

				if (initialVal() && $element.parent().find("input").size() > 0) {
					ko.bindingHandlers.portselect.setupInitialPort(element, valueAccessor, allBindingsAccessor, icon, promt);

				}
			}

			etrAjax.get({
				app: 'app.ibs',
				service:'/booking/locations/passive/TK/' + i18n.getUserLocale(),
				callback:function(response) {
					if(response.data) {
						passivePorts = response.data;
					}
				}
			});

			$element.addClass('selectpicker').selectpicker({
				showSubtext : showSubtext,
				liveSearch : liveSearch,
				dropupAuto : dropupAuto,
				size : size,
				width : '100%'
			});
			
			/*Helpful instructions for screen-reader users*/
			var buttonInstruction = from ? i18n.get('Label-OB-256') : i18n.get('Label-OB-257');//'From, To activate search field, click'
			var searchInstruction = i18n.get('Label-OB-258');
			$element.parent().find('button').attr('aria-label', buttonInstruction);
			$element.parent().find('input').attr('aria-label', searchInstruction);
			$element.parent().find("input").attr('data-v-id', $element.prop('id'));
			$element.parent().find('button .filter-option').attr('aria-hidden', 'true');
			
			$element.parent().on('click', function(event) {
				if ($element.children('optgroup').length === 0) {
					ko.bindingHandlers.portselect.setupFullCityList(element, valueAccessor, allBindingsAccessor, icon, promt, false, restrictedCountries, restrictedPortsObs);
				}
			});
			
			$element.change(function() {
				ko.bindingHandlers.portselect.inputChangedEvent(this, valueAccessor, allBindingsAccessor);
			});
			
			$element.parent().find("input").focusout(function(e) {
				$element.parent().find("button").attr('style', 'outline: none');
			});

			$element.parent().find("input").focusin({
				"promt" : promt
			}, function(e) {
				var button = $element.parent().find("button").attr('style', 'outline: #4285F4 solid 2px!important');
				$(".calendar-holder").removeClass('on');
				if (e.target.value.length === 0 && allBindingsAccessor().portselect.selectedPortData && allBindingsAccessor().portselect.selectedPortData() && !allBindingsAccessor().portselect.selectedPortData().code) {

					var optiongroupPortsHTML = promt;

					optiongroupPortsHTML += '<option data-icon="icon-globe" value="cityList" data-content="<i class=\'glyphicon icon-globe\'></i><span class=\'label-full 1\'>' + i18n.get('Link-OB-01') + '</span>">' + i18n.get('Link-OB-01') + '</option>';
					$element.html(optiongroupPortsHTML);
					$element.selectpicker('refresh');
					ko.bindingHandlers.portselect.setValue(allBindingsAccessor, "");
				}
				
				$element.find("button").blur();
			});

			if (inputFocusHandler) {
				$element.parent().find("button").on('click', function(event, disableInputFocusHandler) {
					if (!disableInputFocusHandler) {
						inputFocusHandler();
					}
				});
			}

			$element.parent().on('keyup', 'input', {
				"promt" : promt
			}, function(e) {
				var searchBoxInputValue = diacriticsHelper.removeDiacritics(e.target.value);
				searchBoxInputValue = $("<div>").text(searchBoxInputValue).html();
				
				if (e.keyCode !== 38 && e.keyCode !== 40 && searchBoxInputValue.length > 0) {

					locations.get([searchBoxInputValue], function(resultArr) {
						if(awardOnly){
							resultArr = ko.bindingHandlers.portselect.processAward(awardOnly, resultArr);
						}else if(starAwardOnly){
							resultArr = ko.bindingHandlers.portselect.processStarAward(starAwardOnly, resultArr);
						}else if(getAllPorts){
							var searchValue = searchBoxInputValue.toLowerCase();

							var filteredPassivePorts = passivePorts.ports.filter(function(item) {
								return item.code.toLowerCase().includes(searchValue) || item.name.toLowerCase().includes(searchValue);
							});
							resultArr = resultArr.concat(filteredPassivePorts);
						}
						
						if (restrictedPortsObs && ko.unwrap(restrictedPortsObs).length > 0) {
							resultArr = ko.bindingHandlers.portselect.processRestrictedPorts(restrictedPortsObs, resultArr);
						}
						if (resultArr.length > 0) {
							ko.bindingHandlers.portselect.processSearchPortResult(resultArr, $element, icon, e.data.promt, valueAccessor);
						} else {
							etrAjax.get({
								app : 'app.ibs',
								service : '/booking/attractionpoints/' + encodeURIComponent(searchBoxInputValue.replace('/', '')),
								disableLoader : true,
								callback : function(response) {
									var i, j;
									if (restrictedPortsObs && ko.unwrap(restrictedPortsObs).length > 0) {
										response.data = ko.bindingHandlers.portselect.processRestrictedPorts(restrictedPortsObs, response.data);
									}

									if (response.data.length !== 0 && e.data) {

										var optiongroupPortsHTML = e.data.promt;
										var exactMatchList = [];
										var matchList = [];
										for (i = 0; i < response.data.length; i++) {
											if (response.data[i].name.toLowerCase().indexOf(searchBoxInputValue.toLowerCase()) == 0) {
												exactMatchList.push(response.data[i]);
											} else {
												matchList.push(response.data[i]);
											}
										}
										for (i = 0; i < exactMatchList.length; i++) {
											response.data[i] = exactMatchList[i];
										}
										for (i = 0; i < matchList.length; i++) {
											var y = exactMatchList.length + i;
											response.data[y] = matchList[i];
										}
										for (i = 0; i < response.data.length; i++) {
											var nearByAirPortText = i18n.getWithArgs('TextField-OB-398', { 'numberofairports' : response.data[i].airports.length, 'countP' : 'numberofairports' })
											optiongroupPortsHTML += '<optgroup label="' + response.data[i].name + '(' + nearByAirPortText+ ')">';

											for (j = 0; j < response.data[i].airports.length; j++) {
												var option = response.data[i].airports[j];
												var optionHTML = '<option  data-value=\'' + escapeHtml(JSON.stringify(option)) + '\' data-icon="' + option.name + '"  value="' + option.code + '\" data-content="<i class=\'glyphicon rotateRTL ' + icon + '\'></i><span class=\'label-short\'>' + option.city.name + '</span><span class=\'label-full 2\'>' + option.city.name + ',' + i18n.get("portnamelookup." + option.code) + ' (' + option.code + ') <span portselect-id=\'distance' + option.code + '\'> (' + option.distance + ' km)</span><span class=\'label-seperator\'>, </span><span class=\'label-subtext\'>' + option.country.name + '</span>' + '</span><span class=\'label-seperator\'> </span><span class=\'label-subtext\'>' + '' + '</span>">' + option.city.name + '</option>';

												optiongroupPortsHTML += optionHTML;

											}
											optiongroupPortsHTML += '</optgroup>';

										}

										var resultFragment = promt;
										e.target.value = searchBoxInputValue;
										resultFragment += optiongroupPortsHTML;
										$('#textPort').html(resultFragment);
										$element.selectpicker('refresh');
										
										return;
										
									}
									if ((response.length==null||response.length === 0)&&((response.data==null)||(response.data.length==0))) {
										
										var prompt="";
										if(e.data)
											prompt=e.data.promt;
										ko.bindingHandlers.portselect.setupFullCityList(element, valueAccessor, allBindingsAccessor, icon, prompt, true, restrictedCountries, restrictedPortsObs);
										$element.next().addClass("empty-selectpicker");
									} else {
										$element.next().removeClass("empty-selectpicker");
										
									}
									$element.selectpicker('refresh');
								}
							});
						}
						
						var searchResultText = i18n.get('Label-OB-262');
						$('#' + notificationFieldId).text("Search results have been listed. Use up and down arrows to navigate options.");
						
					});
				} else if (searchBoxInputValue.length === 0) {
					ko.bindingHandlers.portselect.setupFullCityList(element, valueAccessor, allBindingsAccessor, icon, e.data.promt, false, restrictedCountries, restrictedPortsObs, searchBoxInputValue, e.keyCode);
					allBindingsAccessor().value(searchBoxInputValue);

				} else if (e.keyCode !== 38 && e.keyCode !== 40) {
					var promt = e.data.promt;
					$element.html(promt);
					$element.selectpicker('refresh');
					$element.next().addClass("empty-selectpicker");
				} else if(e.keyCode == 38 || e.keyCode == 40) {
					var activeListItem = $element.next().find('li.active');
					var activePort = activeListItem.find('.label-full').text();
					var selectText = i18n.get('Label-OB-259');
					$('#' + notificationFieldId).text(activePort + ', ' + selectText);
				}
				
				if (!window.isPhone && resizeBackground && searchBoxInputValue.length > 0
						&& $("#schedule #minibooker .middle-wrapper").hasClass('middle-container')) {
					$('#schedule #minibooker .middle-wrapper').removeClass('middle-container');
					$("#schedule #minibooker #animated-text").height($("#schedule #minibooker #animated-text").height()).css({
						'overflow' : 'hidden'
					});
					$("#schedule #minibooker #animated-text").parent().animate({
						'opacity' : 0
					}, 300);
					$("#schedule #minibooker").animate({
						'margin-top' : -80
					}, 500, function() {
						$("#schedule #minibooker").removeClass('animate-page');
					});
				}
				
				ko.bindingHandlers.portselect.removeTitleFromButton($element);

			});
			
			// Fix Hover Title
			ko.bindingHandlers.portselect.removeTitleFromButton($element);
			$element.parent().find('.bootstrap-select button').hover(function() {
				$(this).removeAttr('title');
			});
			
			$element.parent().find('.bootstrap-select button').on('click', function() {
				ko.bindingHandlers.portselect.removeTitleFromButton($element);
			});
			
			$element.parent().find('#schedule .bootstrap-select').on('click', function() {
				if (!$('body').hasClass('schedule')) {
					if ($('#schedule .middle-wrapper .container').attr('style')) {
						$('#schedule .middle-wrapper .container').removeAttr('style');
					}

				}
				if ($('.popup').hasClass('on')) {
					$('.popup').removeClass('on');
				}
				$('body').addClass('schedule');
			});

			if (initialVal && initialVal()) {
				ko.bindingHandlers.portselect.setupInitialPort(element, valueAccessor, allBindingsAccessor, icon, promt);
			}
		},
		
		removeTitleFromButton: function($element) {
//			setTimeout(function(){
				$element.parent().find('.bootstrap-select button').removeAttr('title');
//			}, 100);
		},

		processSearchPortResult : function(resultArr, $element, icon, promt, valueAccessor) {
			var optiongroupPortsHTML = '<optgroup label="' + i18n.get('Label-OB-74') + '">';

			var optiongroupCountriesHTML = '<optgroup label="' + i18n.get('Label-OB-75') + '">';

			var disableCityOption = valueAccessor().disableCityOption || false;

			var hasPort = false;
			var hasCountry = false;

			for (var j = 0; j < resultArr.length; j++) {
				
				var option = resultArr[j];

				var optionHTML = ";"

				if (option.type === "port" || option.type=="city") {
					var showOption = true;
					hasPort = true;

					var portDesc = '<span portselect-id=\'portTXT' + option.code + '\'>' + option.port.name + "</span><span>" + ' (' + option.port.code + ')' + '</span>' + '<span portselect-id=\'city' + option.code + '\'>, ' + option.city.name + '</span>';

					if (option.ports != null && option.ports.length > 1 && !disableCityOption) {
						portDesc = option.city.name + ' ' + i18n.get('Label-OB-250') + ', ' + '<span  portselect-id=\'portCount' + option.code + '\'>' + i18n.getWithArgs('TextField-OB-215', { 'numberofairports' : option.ports.length, 'countP' : 'numberofairports' }) + '</span>';
						optionHTML = '<option data-value=\'' + escapeHtml(JSON.stringify(option)) + '\' data-icon="icon-globe" value="' + option.code + '" data-content="<i class=\'glyphicon icon-globe\'></i><span class=\'label-short\'>' + option.city.name + '</span><span class=\'label-full 3 cityOptionDisabled\'>' + portDesc + '</span><span class=\'label-seperator\'>, </span><span portselect-id=\'country' + option.code + '\' class=\'label-subtext\'>' + option.country.name + '</span></span></span><span class=\'label-seperator\'> </span><span class=\'label-subtext\'>' + '' + '</span>">' + option.city.name + '</option>';
					} else if (option.ports.length > 1 && disableCityOption) {
						showOption = false;
					}
					
					if (option.code == null) {
						option.code = option.port.code
					}
					
					if (option.ports.length < 1) {
						optionHTML = '<option data-value=\'' + escapeHtml(JSON.stringify(option)) + '\'  value="' + option.code + '" data-content="<i class=\'glyphicon rotateRTL ' + icon + '\'></i><span class=\'label-short\'>' + option.city.name + '</span><span class=\'label-full 4\'>' + portDesc + '</span><span class=\'label-seperator\'>, </span><span portselect-id=\'country' + option.code + '\' class=\'label-subtext\'>' + option.country.name + '</span>">' + '</option>';
					}

					if (showOption) {
						optiongroupPortsHTML += optionHTML;
					}

				} else {
					hasCountry = true;
					var fc = option.name.charAt(0);
					optionHTML = '<option data-icon="icon-globe" value="countryPorts_' + fc + '_' + option.code + '" data-content="<i class=\'glyphicon icon-globe\'></i><span class=\'label-full 5\'>' + option.name + '</span>">' + option.name + '</option>';
					optiongroupCountriesHTML += optionHTML;
				}
			}

			optiongroupPortsHTML += '</optgroup>';

			var resultFragment = promt;

			if (hasPort)
				resultFragment += optiongroupPortsHTML;

			if (hasCountry)
				resultFragment += optiongroupCountriesHTML;

			$element.html(resultFragment);
			$element.selectpicker('refresh');
			if (resultArr.length > 0) {
				$element.next().removeClass("empty-selectpicker");
			} else {
				$element.next().addClass("empty-selectpicker");
			}
		},

		addCityListEvents : function(element, valueAccessor, allBindingsAccessor, icon, promt, noResult, restrictedCountries, restrictedPortsObs) {
			var $element = $(element);
			$element.parent().children([ "option" ]).off("click.cityList");
			$element.parent().children([ "option" ]).on('click.cityList', function() {
				var _index = 0;
				$element.parent().find('li').each(function(index){				
					if($(this).hasClass('active')){
						_index = index;
					}
				});
				$element.parent().find('select').each(function(){
					$(this).find('option')[_index].selected = true;
				});
				
				var optionVal = $element.val();
				var countryShortcut = optionVal.indexOf("countryPorts_") === 0;

				var countryCode = null;
				var countryFC = null;
				if (countryShortcut) {
					countryCode = optionVal.substring(15);
					countryFC = optionVal.substring(13, 14)
				}

				if (optionVal === "cityList" || countryShortcut) {

					var countryQuery = {
						cache : false,
						app : 'app.ibs',
						service : '/booking/countries/TK',
						reloadPageCSRF: true,
						callback : function(response) {
							var countryOptionsHTML = '';
							var firstLetter = '';
							var countryCount = 0;
							var cityCount = 0;
							var charsHTML = "";
							for (var i = 0; i < response.data.length; i++) {
								if (restrictedCountries === undefined || restrictedCountries.indexOf(response.data[i].code) > -1) {
									countryCount++;
									var currentFirstLetter = response.data[i].name.charAt(0);
									if (firstLetter !== currentFirstLetter) {
										cityCount++;
										firstLetter = currentFirstLetter;
										countryOptionsHTML += '<li id="alphabet_' + cityCount + '" data-value="' + response.data[i].code + '"><span>' + firstLetter + '</span></li>';
										charsHTML += '<li><a data-attr="' + cityCount + '" data-value="' + response.data[i].code + '">' + firstLetter + '</a></li>';				
									}
									countryOptionsHTML += '<li class="country-item" data-value="' + response.data[i].code + '"><a>' + response.data[i].name + '</a></li>';
								}
							}

							Eteration.loadStaticFragment({
								app : 'app.ibs',
								module : "schedulenew",
								tmpl : "countrylistnew",
								el : $('#countryList'),
								success : function() {
									$("#countryOptions").html(countryOptionsHTML);

									var countryCountText = i18n.getWithArgs('TextField-OB-110', {
										'# of Countries' : countryCount
									});

									$("#countryCount").html(countryCountText);

									$(".country-item").on("click", function() {
										var selectedCountry = $(this).data('value');
										$(".selected").removeClass("selected");
										$(this).children("a").addClass("selected");
										var countryPortsQuery = {
											cache : false,
											app : 'app.ibs',
											service : '/parameters/ports/TK/country/' + selectedCountry,
											reloadPageCSRF: true,
											callback : function(portQueryResponse) {

												var portsHTML = "";
												var portCount = 0;
												for (var j = 0; j < portQueryResponse.data.length; j++) {
													var location = portQueryResponse.data[j];
													if (restrictedPortsObs === undefined || restrictedPortsObs.indexOf(location.port.code) > -1) {

														var portDesc = location.port.name + ' (' + location.port.code + ')';

														if (location.ports.length > 1) {
															portDesc = location.city.name + ' ' + i18n.get('Label-OB-250') + ' ' + i18n.getWithArgs('TextField-OB-215', {
																'numberofairports' : location.ports.length,
																'countP' : 'numberofairports'
															});
														} else {
															portCount++;
														}

														portsHTML += '<li class="port-item" data-multi="' + location.multi + '" data-value="' + location.port.code + '"><a role="button" tabindex="0">' + location.city.name + ', ' + portDesc + '</a></li>';
													}
												}

												var airportCountText = i18n.getWithArgs('TextField-OB-81', {
													'# of Airports' : portCount
												});

												$("#portCount").html(airportCountText);

												$('#countryPorts').html(portsHTML);

												$('#countryPorts').parent().animate({
													scrollTop : 0
												}, 0);
												$(".cityairport-list").perfectScrollbar('update');

												$('.cityairport-list a').keydown(function(e) {
													switch (e.keyCode) {
													case 40:
														e.preventDefault();
														$(this).parent().next().find('a').focus();
														break;
													case 38:
														e.preventDefault();
														$(this).parent().prev().find('a').focus();
														break;
													case 37:
														e.preventDefault();
														$('.country-list').find('.selected').focus();
														break;
													}
												});

												$(".port-item").on("click", function() {
													var selectedPort = $(this).data('value');
													var multi = $(this).data('multi');
													var domestic = $(this).data('domestic');
													locations.get(selectedPort, function(resultArr) {

														if (resultArr.length > 0) {

															ko.bindingHandlers.portselect.processSearchPortResult(resultArr, $element, icon, promt, valueAccessor);
															ko.bindingHandlers.portselect.setValue(allBindingsAccessor, {
																'code' : selectedPort,
																'multi' : multi,
																'domestic' : domestic
															});
                                                            var hasMulti = underscore.any(resultArr, function(item){return item.multi;});
                                                           
                                                            if (multi||hasMulti) {
                                                            	var index = 0;
																for (var int = 0; int < resultArr.length; int++) {
																	if (resultArr[int].multi==multi && selectedPort && selectedPort==resultArr[int].code) {
																		index = int;
																		break;
																	}
																}

																if($element.find('option').length > index+1)
																	$element.find('option')[index+1].selected = true;
															}

															$element.selectpicker('refresh');
															if($('#countrylistmodal')!=null)															
																$('#countrylistmodal').modal("hide");
															$element.trigger('change');
															if($('.general-booker').length > 0) {
																$element.parents('.tk-input-field').find('.booker-text-label').addClass('active')
																	.parent().find('input.form-control').val(selectedPort);
															}
														}

													});

												});

											}
										};
										etrAjax.get(countryPortsQuery);
									});

									$('#countrylistmodal').modal("show");
									$('.country-alphabet-list').html(charsHTML);
									ko.applyBindings({}, $("#countryList")[0]);

									$('#countrylistmodal').on('shown.bs.modal', function() {


										$('.country-alphabet').trigger('refresh');
										$('.country-alphabet a').parent().removeClass("active");
										$('.country-alphabet a').first().parent().addClass("active");
										$('.country-alphabet a').click(function() {
											if(!$(this).parent().hasClass("active")) {
												$('.country-alphabet a').parent().removeClass("active");
												$(this).parent().addClass("active");
												$(this).focus();
												var scrollTarget = $(this).attr('data-attr');
												$('.country-list').stop(0).animate({
												    scrollTop: $('.country-list').scrollTop() + $( '#alphabet_' + scrollTarget).position().top
												}, 1000);
											}
										});

										$('.country-alphabet a').keydown(function(e) {
											switch (e.keyCode) {
											case 40:
												e.preventDefault();
												$(this).parent().next().find('a').focus();
												break;
											case 38:
												e.preventDefault();
												$(this).parent().prev().find('a').focus();
												break;
											case 39:
												e.preventDefault();
												var alphabetId = $(this).attr('href');
												$(alphabetId).next().find('a').focus();
												break;
											}
										});

										$('.country-list a').keydown(function(e) {
											switch (e.keyCode) {
											case 40:
												e.preventDefault();
												$(this).parent().next().find('a').focus();
												break;
											case 38:
												e.preventDefault();
												$(this).parent().prev().find('a').focus();
												break;
											case 39:
												e.preventDefault();
												$('.cityairport-list').find('a').first().focus();
												break;
											case 37:
												e.preventDefault();
												$('.country-alphabet-list').find('.active').find('a').focus();
												break;
											}
										});

										var height = $(".country-alphabet-list").outerHeight();

										if (height < 150) {
											var mt = $("#countrylistmodal > .modal-dialog").css("margin-top").replace("px", "");
											var mb = $("#countrylistmodal > .modal-dialog").css("margin-bottom").replace("px", "");
											height = $(window).height() - mt - mb - 61; // 61
																						// height
																						// of
																						// the
																						// first
																						// row
										}

										$(".country-list").height(height);
										$(".cityairport-list").height(height);
										if(!window.isPhoneOrTablet){	
											$(".country-list").perfectScrollbar({
												wheelSpeed : 1
											});
											$(".cityairport-list").perfectScrollbar({
												wheelSpeed : 1
											});
										
											$(".country-list").on('ps-scroll-y', function() {
												$(".country-list li").not(".country-item").each(function() {
													var DH = $(this);
													if (DH.position().top <= 60 && -45 <= DH.position().top) {
														var id = DH.attr('id')
														$('.country-alphabet a[href="#' + id + '"]').trigger("click");
													}
												});
											});
										}else{
											$(".country-list").each(function () {
											    this.style.setProperty('overflow-y', 'visible','important' );
											});
											$(".cityairport-list").each(function () {
											    this.style.setProperty('overflow-y', 'auto','important' );
											});
										
										}
									});

									$element.html($element.html());
									$element.selectpicker('refresh');
									$element.next().addClass("empty-selectpicker");

									allBindingsAccessor().value("");
									setTimeout(function() {
										if (countryCode != null) {

											$("[data-value=" + countryCode + "]").each(function(){this.click()});
											$(".country-list").scrollTop($(".country-list").scrollTop() + $("[data-value=" + countryCode + "]").position().top);
										} else {
											$("#countryOptions").children()[1].click();
										}
									}, 1000);

								}

							});

						}
					};

					etrAjax.get(countryQuery);
				}
			});
		},

		setupFullCityList : function(element, valueAccessor, allBindingsAccessor, icon, promt, noResult, restrictedCountries, restrictedPortsObs, value, keyValue) {

			var $element = $(element);

			var optiongroupPortsHTML = promt;

			if (noResult){
				optiongroupPortsHTML += '<option disabled>' + i18n.get('Label-OB-98') + '</option>';
			}

			optiongroupPortsHTML += '<option data-icon="icon-globe" value="cityList" data-content="<i class=\'glyphicon icon-globe\'></i><span class=\'label-full 6\'>' + i18n.get('Link-OB-01') + '</span>">' + i18n.get('Link-OB-01') + '</option>';
			$element.html(optiongroupPortsHTML);

			if (value === undefined || (keyValue !== 40 && keyValue !== 38)) {
				$element.selectpicker('refresh');
				ko.bindingHandlers.portselect.addCityListEvents(element, valueAccessor, allBindingsAccessor, icon, promt, noResult, restrictedCountries, restrictedPortsObs);
			}

		},

		inputChangedEvent : function(element, valueAccessor, allBindingsAccessor) {
			var selectedDataValue = $(element).find(":selected").data("value");
			var selectedValue=$(element).find(":selected").val();
			var parent = $(element).parent();

			var eraseElementText = function(i, selected){ $(selected).text('') };
			
			ko.bindingHandlers.portselect.setValue(allBindingsAccessor, selectedDataValue);
			
			parent.find("button [portselect-id='distance" + selectedValue + "']").each(eraseElementText);
			parent.find("button [portselect-id='country" + selectedValue + "']").each(eraseElementText);
			parent.find("button [portselect-id='city" + selectedValue + "']").each(eraseElementText);
			parent.find("button [portselect-id='portCount" + selectedValue + "']").each(eraseElementText);
			
			var fullLabel = parent.find("button .label-full.cityOptionDisabled");
			var formattedText = fullLabel.text().replace(',', '');
			fullLabel.text(formattedText);
			
			var portLabel = parent.find("button [portselect-id='portTXT" + selectedValue + "']");
			
			if (portLabel.text().length > 22) {
				portLabel.text(portLabel.text().substring(0, 19) + "...");
			}
			
			ko.bindingHandlers.portselect.removeTitleFromButton($(element));
			
			
			if(selectedDataValue && selectedDataValue.name){
				var from = valueAccessor().from || false;
				var feedbackText = from ? i18n.get('Label-OB-260') : i18n.get('Label-OB-261');
				
				var notificationFieldId = valueAccessor().notificationFieldId;
				$('#' + 'accessibility-polite-feedback-field').text(selectedDataValue.name + " " + feedbackText);
			}
		}

	};
	
	return {
	    getLocations : function(){
	       return  locations;
	    }
	}
});
